import CarrierProvider from './CarrierDetailsContext';
import CarrierDetails from './CarrierDetails';
import { Page } from 'components';

let Index = () => {
    return (
        <CarrierProvider>
            <Page title="Carrier" maxWidth='md'>
                <CarrierDetails />
            </Page>
        </CarrierProvider>
    )
}

export default Index;